'use strict'

const BlockMap = {
    init: function () {
        const mapContainer = document.querySelector('.f-map');
        const hotspots = document.querySelectorAll('.hotspot');
        const btnsZoom = document.querySelectorAll('.js-map-zoom');
        if (mapContainer && hotspots.length > 0) {
            for (let i = 0; i < hotspots.length; i++) {
                hotspots[i].addEventListener('click', function (e) {
                    for (let x = 0; x < hotspots.length; x++) {
                        if (hotspots[x] == this) {
                            hotspots[x].classList.add('open');
                        } else {
                            hotspots[x].classList.remove('open');
                        }
                    }
                    if (hotspots[i].querySelector('.hotspot__infos-close')){
                        hotspots[i].querySelector('.hotspot__infos-close').addEventListener('click', (e) => {
                            e.stopPropagation()
                            hotspots[i].classList.remove('open')
                        })
                    }
                });
            }
            if (btnsZoom.length > 0) {
                btnsZoom.forEach(btn => {
                    btn.addEventListener('click', ()=> {
                        mapContainer.classList.toggle('zoomed')
                    })
                })
            }
        }
    },
}


export default BlockMap;
